import { module } from 'modujs';

export default class extends module {
    init() {
        this.$bleams = this.$('bleam');

        for (let i = 0; i < this.$bleams.length; i++) {
            const bleam = this.$bleams[i];

            bleam.style.left = `${Math.random() * window.innerWidth}px`;
            bleam.style.animationDelay = `${0.3 + (Math.random()*0.5)}s`
        }
    }

    updatePositions() {
        for (let i = 0; i < this.$bleams.length; i++) {
            const bleam = this.$bleams[i];

            bleam.style.left = `${Math.random() * window.innerWidth}px`;
            bleam.style.animationDelay = `${0.3 + (Math.random()*0.5)}s`
        }
    }
}
